import React from "react";
import { Container, Card } from "react-bootstrap";
import { PRIVACY_POLICY_VERSION } from "./ConsentCheckbox";

/**
 * TASK-19 · Política de privacidad (placeholder estático, Ley 1581).
 * Public page linked from the consent checkbox and PrivacyPage.
 * Replace the body copy with the legally-reviewed text before production.
 */
function PrivacyPolicyPage() {
  return (
    <Container className="py-4" style={{ maxWidth: 760 }}>
      <Card className="shadow-sm">
        <Card.Body className="p-4">
          <h1 className="h4 mb-1">Política de tratamiento de datos personales</h1>
          <p className="text-muted small mb-4">Versión {PRIVACY_POLICY_VERSION}</p>

          <p>
            En cumplimiento de la Ley 1581 de 2012 (Colombia) y normas
            concordantes, esta plataforma trata datos personales de estudiantes
            y docentes en nombre de cada academia (responsable del tratamiento),
            actuando como encargado.
          </p>

          <h2 className="h6 mt-3">Finalidad</h2>
          <p className="text-muted">
            Gestión académica: registro de clases (grade card), asistencia,
            saldos de horas, pagos y honorarios. No se solicitan datos que no se
            usen para estas finalidades (principio de minimización).
          </p>

          <h2 className="h6 mt-3">Derechos del titular</h2>
          <p className="text-muted">
            Acceso, rectificación y supresión. Puedes exportar tus datos o
            solicitar la eliminación de tu cuenta desde «Mis datos personales».
          </p>

          <h2 className="h6 mt-3">Retención y eliminación</h2>
          <p className="text-muted">
            Al cancelar una academia, sus datos se exportan y se purgan tras un
            periodo de gracia. Nunca se eliminan en caliente.
          </p>

          <p className="text-muted small mt-4 mb-0">
            <em>
              Texto de muestra — debe reemplazarse por la política revisada
              legalmente antes de producción.
            </em>
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
}

export { PrivacyPolicyPage };
